import type { GetStatisticsResponseDto } from 'shared/dtos/statistics.dto';

import { createAsyncThunk } from '@reduxjs/toolkit';
import StatisticsService from 'services/statistics.service';

const statisticsService = new StatisticsService();

export const getStatisticsThunk = createAsyncThunk<GetStatisticsResponseDto>(
  'statistics/getStatistics',
  async (_, thunkAPI) => {
    try {
      const result = await statisticsService.getStatistics();
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
